
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/item/[slug]",
      function () {
        return require("private-next-pages/discover/item/[slug].js");
      }
    ]);
  